/***
 *
 *   AUTO-DELETE CARD STYLES
 *   Grouped panel for the completed-tickets lifecycle setting — nested delay
 *   under the switch so the two controls read as one decision. Slightly warmer
 *   border when on so the destructive path stands out without alarm chrome.
 *
 **********/

const Style = {
    panel: 'rounded-md border border-border bg-surface-elevated/40 p-4 space-y-4 [&_.relative.mb-4]:mb-0',
    panelOn: `rounded-md border border-warning/40 bg-warning/5 p-4 space-y-4
    [&_.relative.mb-4]:mb-0`,
    delayBlock: 'ml-12 space-y-2 border-l-2 border-warning/50 pl-4',
    delayLabel: 'block text-sm font-medium text-text-primary',
    delayRow: 'flex flex-wrap items-center gap-2',
    daysInput: `h-10 w-24 rounded-md border border-input bg-surface px-3 py-2 text-sm tabular-nums
    text-text-primary shadow-sm transition-colors focus-visible:outline-none
    focus-visible:ring-2 focus-visible:ring-ring`,
    daysSuffix: 'text-sm text-text-secondary',
    summary: 'text-xs leading-relaxed text-text-primary',
    hint: 'text-xs leading-relaxed text-text-muted',
    offHint: 'text-xs leading-relaxed text-text-muted',
    error: 'mt-3 text-sm text-error',
    footer: 'mt-4 flex items-center gap-3',
};

export default Style;
